function canvasToFile(canvas: HTMLCanvasElement, type: string, filename: string): Promise<File> {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      const file = new File([blob], filename, {type: type});
      resolve(file);
    }, type);
  });
}

export default canvasToFile;
